import { PropsWithChildren } from 'react';
import { OptInToSmsCheckbox } from '~/components/inputs/opt-in-to-sms-checkbox';
import { Address } from './address';
import { AddressSecondary } from './address-secondary';
import { AgentName } from './agent-name';
import { BudgetBillingCheckbox } from './budget-billing-checkbox';
import { BusinessName } from './business-name';
import { Email } from './email';
import { EmailTelesales } from './email-telesales';
import { EstimatedAnnualKwh } from './estimated-annual-kwh';
import { EstimatedDailyKwh } from './estimated-daily-kwh';
import { EstimatedMonthlyKwh } from './estimated-monthly-kwh';
import { FirstName } from './first-name';
import { InviteCode } from './invite-code';
import { LastName } from './last-name';
import { MeterNumber } from './meter-number';
import { NameOnDocument } from './name-on-document';
import { Password } from './password';
import { Phone } from './phone';
import { PromoCode } from './promo-code';
import { SecondaryIdentifier } from './secondary-identifier';
import { StripePaymentId, StripeCustomerId } from './stripe-payment';
import { UtilityAccountNumber } from './utility-account-number';
import { UtilityEmail } from './utility-email';
import { UtilityPassword } from './utility-password';
import { UtilityUsername } from './utility-username';
import { ZipCode } from './zip-code';

export const Inputs = ({ children }: PropsWithChildren<{}>) => children;

Inputs.Address = Address;
Inputs.AddressSecondary = AddressSecondary;
Inputs.AgentName = AgentName;
Inputs.BudgetBillingCheckbox = BudgetBillingCheckbox;
Inputs.BusinessName = BusinessName;
Inputs.Email = Email;
Inputs.EmailTelesales = EmailTelesales;
Inputs.EstimatedAnnualKwh = EstimatedAnnualKwh;
Inputs.EstimatedDailyKwh = EstimatedDailyKwh;
Inputs.EstimatedMonthlyKwh = EstimatedMonthlyKwh;
Inputs.FirstName = FirstName;
Inputs.InviteCode = InviteCode;
Inputs.LastName = LastName;
Inputs.MeterNumber = MeterNumber;
Inputs.NameOnDocument = NameOnDocument;
Inputs.Password = Password;
Inputs.Phone = Phone;
Inputs.OptInToSmsCheckbox = OptInToSmsCheckbox;
Inputs.PromoCode = PromoCode;
Inputs.UtilityAccountNumber = UtilityAccountNumber;
Inputs.SecondaryIdentifier = SecondaryIdentifier;
Inputs.StripePaymentId = StripePaymentId;
Inputs.StripeCustomerId = StripeCustomerId;
Inputs.UtilityUsername = UtilityUsername;
Inputs.UtilityEmail = UtilityEmail;
Inputs.UtilityPassword = UtilityPassword;
Inputs.ZipCode = ZipCode;
